import React from 'react';

const Valorbr2 = (value) => {
  let [integer, decimal] = value.toFixed(2).split('.');
  integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, '.'); // Adiciona pontos nos milhares
  return `${integer},${decimal}`;
};

const Valorbr0 = (value) => {
  let [integer, decimal] = value.toString().split('.');
  integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return decimal ? `${integer},${decimal}` : integer;  

};


const SvgLogin = () => {
  return (
<svg height="64px" width="64px" version="1.1" id="_x32_" xmlns="http://www.w3.org/2000/svg" 
   viewBox="0 0 512 512" >
<g fill="#fff" stroke="none">
<path d="M155.81,0v173.889h33.417V33.417h235.592l-74.87,50.656c-8.469,5.727-13.535,15.289-13.535,25.503v286.24 H189.227V282.079H155.81v147.154h180.604v70.93c0,4.382,2.423,8.404,6.29,10.451c3.867,2.056,8.558,1.811,12.189-0.644 l119.318-80.736V0H155.81z"></path> 
<path d="M228.657,290.4c0,1.844,1.068,3.524,2.75,4.3c1.664,0.775,3.638,0.514,5.042-0.685l78.044-66.035 l-78.044-66.034c-1.404-1.2-3.378-1.46-5.042-0.686c-1.681,0.775-2.75,2.456-2.75,4.3v33.392H37.79v58.064h190.868V290.4z"></path> 
</g>
</svg>
);
};


const SvgTab01 = () => {return(
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="46pt" height="46pt" viewBox="0 0 46 46"  preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,182.000000) scale(0.100000,-0.100000)"
fill="#fff" stroke="none">
<path d="M106 1715 c-47 -36 -60 -114 -26 -158 12 -15 20 -41 20 -64 1 -55 18
-73 72 -73 38 0 46 4 56 25 7 14 12 39 12 55 0 16 9 45 21 65 43 73 -9 165
-93 165 -24 0 -51 -7 -62 -15z m109 -23 c18 -13 35 -51 35 -77 0 -13 -13 -39
-30 -57 l-29 -33 -1 31 c0 17 7 37 15 44 14 12 21 40 10 40 -3 0 -14 -6 -25
-12 -16 -10 -24 -10 -40 0 -33 20 -46 2 -16 -23 16 -14 26 -33 26 -49 0 -29
-5 -32 -25 -13 -8 6 -21 18 -30 25 -20 17 -19 76 1 107 13 20 25 25 58 25 22
0 46 -4 51 -8z m5 -201 c0 -40 -46 -55 -82 -27 -32 24 -21 36 32 36 28 0 50
-4 50 -9z"/>
</g>
</svg>
);};

const SvgTab02 = () => {return(
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"  
width="46pt" height="46pt" viewBox="0 0 46 46"  preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,182.000000) scale(0.100000,-0.100000)"
fill="#fff" stroke="none">
<path d="M256 1715 c-15 -21 -17 -22 -32 -6 -16 16 -52 14 -65 -3 -3 -4 -17
-12 -32 -18 -27 -12 -38 -33 -18 -33 20 0 22 -31 4 -51 -17 -19 -17 -20 4 -26
18 -4 22 -12 22 -49 0 -42 1 -44 38 -53 85 -22 113 -23 168 -6 l54 17 0 50 c0
37 5 54 18 64 15 11 15 16 4 34 -11 19 -11 25 2 39 34 37 21 46 -85 56 -61 7
-68 5 -82 -15z m83 -9 c0 -6 16 -11 35 -13 26 -2 32 -6 26 -17 -7 -10 -24 -12
-74 -7 -62 7 -65 9 -54 27 12 19 67 27 67 10z m-123 -27 c5 -14 -43 -35 -62
-28 -22 9 -18 19 13 31 31 12 44 11 49 -3z m23 -29 c0 -10 -10 -15 -27 -15
l-28 1 25 14 c31 18 30 18 30 0z m99 5 l26 -1 -25 -14 c-14 -8 -40 -14 -57
-15 -27 0 -33 4 -33 21 0 19 4 21 31 15 17 -3 43 -6 58 -6z m66 -40 c-2 -4
-18 -13 -35 -20 -24 -10 -33 -10 -46 1 -14 12 -12 15 22 30 26 11 43 13 51 7
7 -6 11 -14 8 -18z m-126 -6 c3 -3 -2 -12 -11 -20 -13 -14 -24 -14 -72 -4 -54
11 -69 23 -43 34 13 6 119 -3 126 -10z m82 -46 c17 11 19 9 19 -14 0 -29 -13
-44 -52 -61 l-28 -13 0 57 c0 56 0 56 21 37 17 -15 23 -16 40 -6z m-81 -44 l0
-42 -47 10 c-52 11 -63 21 -63 55 0 19 5 21 55 20 l55 -2 0 -41z"/>
</g></svg>);};

const SvgTab03 = () => {return(
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg"  
  width="46pt" height="46pt" viewBox="0 0 46 46"  preserveAspectRatio="xMidYMid meet">
  <g transform="translate(0.000000,182.000000) scale(0.100000,-0.100000)"
  fill="#fff" stroke="none">
    <path d="M97 1723 c-2 -5 -7 -25 -11 -45 l-7 -38 141 0 140 0 1 -87 1 -88
19 75 c21 83 15 114 -25 126 -12 4 -23 10 -26 13 -5 7 -195 51 -217 51 -7 0
-14 -3 -16 -7z"/>
<path d="M22 1618 c-8 -8 -12 -47 -12 -108 0 -61 4 -100 12 -108 17 -17 299
-17 316 0 8 8 12 49 12 120 l0 108 -158 0 c-110 0 -162 -4 -170 -12z m308 -23
c0 -13 -23 -15 -150 -15 -127 0 -150 2 -150 15 0 13 23 15 150 15 127 0 150
-2 150 -15z m0 -115 l0 -70 -150 0 -150 0 0 70 0 70 150 0 150 0 0 -70z"/>
<path d="M62 1495 l0 -25 120 0 120 0 0 25 0 25 -120 0 -120 0 0 -25z"/>
</g></svg>);};


const SvgTab04 = () => {return(
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg"  
  width="46pt" height="46pt" viewBox="0 0 46 46"  preserveAspectRatio="xMidYMid meet">
  <g transform="translate(0.000000,182.000000) scale(0.100000,-0.100000)"
  fill="#fff" stroke="none">
<path d="M110 1600 c0 -27 -3 -30 -30 -30 -25 0 -30 -4 -30 -25 0 -22 4 -25
35 -25 35 0 35 0 35 -45 0 -38 3 -45 20 -45 17 0 20 7 20 45 0 43 1 45 30 45
25 0 30 4 30 25 0 21 -5 25 -30 25 -27 0 -30 3 -30 30 0 25 -4 30 -25 30 -21
0 -25 -5 -25 -30z"/>
<path d="M260 1545 c0 -25 1 -25 85 -25 84 0 85 0 85 25 0 25 -1 25 -85 25
-84 0 -85 0 -85 -25z"/>
</g></svg>);};

const SvgTab05 = () => {return(
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg"  
  width="46pt" height="46pt" viewBox="0 0 46 46"  preserveAspectRatio="xMidYMid meet">
  <g transform="translate(0.000000,182.000000) scale(0.100000,-0.100000)"
  fill="#fff" stroke="none">
<path d="M133 1718 c-22 -10 -43 -54 -43 -88 0 -10 12 -29 26 -44 67 -67 167
13 122 97 -23 45 -60 57 -105 35z m72 -44 c10 -16 14 -35 11 -49 -11 -44 -81
-44 -92 0 -7 29 21 75 46 75 10 0 25 -12 35 -26z"/>
<path d="M73 1540 c-50 -12 -63 -27 -63 -76 0 -58 14 -64 155 -64 141 0 155
6 155 63 0 23 -4 47 -8 52 -20 29 -161 44 -239 25z m170 -25 l47 -6 0 -40 0
-39 -125 0 -125 0 0 35 c0 21 6 38 14 41 23 9 110 22 126 19 8 -2 36 -6 63
-10z"/>
</g></svg>);};

const SvgTab06 = () => {return(
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg"  
  width="46pt" height="46pt" viewBox="0 0 46 46"  preserveAspectRatio="xMidYMid meet">
  <g transform="translate(0.000000,182.000000) scale(0.100000,-0.100000)"
  fill="#fff" stroke="none">
<path d="M198 1692 c-80 -37 -110 -129 -69 -210 27 -53 75 -76 145 -69 42 4
54 10 87 46 21 23 42 53 45 66 21 83 -63 186 -149 185 -12 0 -39 -8 -59 -18z
m114 -26 c51 -53 68 -79 68 -106 0 -32 -1 -35 -47 -86 -47 -53 -101 -53 -157
-1 -46 43 -54 116 -17 152 44 43 66 55 102 55 21 0 44 -6 51 -14z"/>
<path d="M202 1626 c-28 -28 -26 -57 6 -71 32 -14 30 -44 -3 -37 -37 7 -32
-23 7 -39 24 -10 33 -10 36 -1 2 7 9 12 17 12 42 0 41 66 -1 76 -34 9 -33 43
1 36 34 -6 34 25 -1 38 -33 13 -35 13 -62 -14z m28 -32 c0 -8 -5 -12 -10 -9
-6 4 -8 11 -5 16 9 14 15 11 15 -7z m25 -63 c3 -5 1 -12 -5 -16 -5 -3 -10 1
-10 9 0 18 6 21 15 7z"/>
</g></svg>);};

const SvgTab07 = () => {return(
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg"  
  width="46pt" height="46pt" viewBox="0 0 46 46"  preserveAspectRatio="xMidYMid meet">
  <g transform="translate(0.000000,182.000000) scale(0.100000,-0.100000)"
  fill="#fff" stroke="none">
<path d="M80  1555 l0 -145 145 0 c122 0 145 2 145 15 0 13 -21 15 -130 15 l-130 0 0 130 c0 109 -2 130 -15 130 -13 0 -15 -23 -15 -145z"/>
<path d="M310 1575 c0 -108 1 -115 20 -115 19 0 20 7 20 115 0 108 -1 115 -20 115 -19 0 -20 -7 -20 -115z"/>
<path d="M250 1535 c0 -60 3 -75 15 -75 12 0 15 15 15 75 0 60 -3 75 -15 75 -12 0 -15 -15 -15 -75z"/>
<path d="M200 1505 c0 -33 4 -45 15 -45 11 0 15 12 15 45 0 33 -4 45 -15 45 -11 0 -15 -12 -15 -45z"/>
<path d="M140 1485 c0 -16 6 -25 15 -25 9 0 15 9 15 25 0 16 -6 25 -15 25 -9 0 -15 -9 -15 -25z"/>
</g></svg>);};


const SvgTab08 = () => {return(
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg"  
  width="46pt" height="46pt" viewBox="0 0 46 46"  preserveAspectRatio="xMidYMid meet">
  <g transform="translate(0.000000,182.000000) scale(0.100000,-0.100000)"
  fill="#fff" stroke="none">
<path d="M153 1712 c-46 -25 -93 -93 -93 -136 0 -42 49 -115 89 -132 58 -25
126 -14 165 27 39 40 56 70 56 98 0 19 -6 21 -70 21 l-70 0 0 70 c0 66 -1 70
-22 70 -13 -1 -37 -9 -55 -18z m49 -79 l3 -68 68 -3 c69 -3 74 -5 57 -25 -60
-74 -75 -83 -136 -79 -27 2 -80 51 -93 85 -13 33 -4 80 18 102 30 29 64 55 72
55 4 0 9 -30 11 -67z"/>
<path d="M252 1668 l3 -53 53 -3 c56 -3 62 4 41 51 -12 26 -57 57 -84 57 -13
0 -16 -9 -13 -52z m52 -5 c19 -23 19 -23 -2 -23 -17 0 -22 6 -22 27 0 14 1 24
3 22 1 -2 11 -14 21 -26z"/>
</g></svg>);};


const SvgTab09 = () => {return(
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg"  
  width="46pt" height="46pt" viewBox="0 0 46 46"  preserveAspectRatio="xMidYMid meet">
  <g transform="translate(0.000000,182.000000) scale(0.100000,-0.100000)"
  fill="#fff" stroke="none">
<path d="M160 1635 l0 -85 155 0 155 0 0 85 0 85 -155 0 -155 0 0 -85z"/>
<path d="M34 1653 c-3 -10 -10 -30 -16 -44 -5 -14 -7 -46 -5 -70 3 -36 5 -40
12 -21 14 41 82 42 92 2 5 -19 12 -20 101 -18 65 2 97 7 100 16 3 9 -19 12
-87 12 l-91 0 0 70 0 70 -50 0 c-39 0 -52 -4 -56 -17z m76 -32 c0 -27 -3 -29
-42 -33 -24 -3 -44 -4 -45 -3 -2 1 3 16 9 33 11 27 18 32 45 32 30 0 33 -3 33
-29z"/>
<path d="M40 1515 c-26 -32 13 -81 48 -59 22 14 27 41 12 59 -16 19 -44 19
-60 0z"/>
<path d="M330 1515 c-26 -32 13 -81 48 -59 22 14 27 41 12 59 -16 19 -44 19
-60 0z"/>
<path d="M400 1521 c0 -16 18 -22 45 -15 37 9 31 24 -10 24 -19 0 -35 -4 -35
-9z"/>

</g></svg>);};

const SvgTab10 = () => {return(
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg"  
  width="46pt" height="46pt" viewBox="0 0 46 46"  preserveAspectRatio="xMidYMid meet">
  <g transform="translate(0.000000,182.000000) scale(0.100000,-0.100000)"
  fill="#fff" stroke="none">
<path d="M164 1750 c-66 -34 -99 -117 -74 -184 7 -19 5 -38 -10 -77 -11 -29
-16 -56 -11 -61 4 -4 32 3 62 16 36 16 66 22 90 19 23 -2 54 4 83 17 37 16 51
29 66 63 25 55 25 91 -1 145 -16 33 -32 48 -64 63 -56 25 -90 25 -141 -1z
m132 -34 c16 -14 32 -25 35 -25 10 0 29 -50 29 -76 0 -29 -14 -58 -40 -84 -31
-31 -56 -40 -109 -40 -27 0 -61 -4 -75 -10 -29 -11 -34 0 -11 24 8 8 15 22 15
31 0 9 -7 23 -15 31 -8 9 -15 31 -15 49 0 26 10 43 46 79 55 55 94 61 140 21z"/>
</g></svg>);};


const SvgMov01 = () => {return(
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="46pt" height="46pt" viewBox="0 0 40 35"
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,31.000000) scale(0.100000,-0.100000)"
fill="#fff" stroke="none">
<path d="M0 291 c0 -5 10 -11 23 -13 15 -2 23 -11 25 -28 4 -37 53 -170 63
-170 4 0 7 -12 6 -27 -2 -22 2 -28 18 -28 16 0 20 6 18 28 -1 22 2 27 22 27
20 0 23 -5 22 -27 -2 -24 2 -28 23 -28 22 0 25 4 26 37 l1 37 -66 4 -66 3 67
2 66 2 17 53 c10 28 21 56 26 61 5 6 9 16 9 23 0 10 -27 13 -115 13 -104 0
-115 2 -125 20 -11 20 -60 29 -60 11z m115 -76 c3 -14 7 -36 10 -50 7 -33 -13
-32 -25 0 -21 56 -23 75 -6 75 9 0 18 -11 21 -25z m47 -25 c3 -52 -5 -67 -16
-27 -9 33 -7 77 3 77 5 0 11 -23 13 -50z m53 8 c-8 -49 -12 -58 -26 -58 -5 0
-9 23 -9 50 0 44 2 50 21 50 19 0 20 -4 14 -42z m41 -8 c-5 -27 -15 -50 -22
-50 -8 0 -9 13 -1 50 5 28 15 50 22 50 9 0 9 -12 1 -50z"/>
</g>
</svg>
);};

const SvgMov02 = () => {return(
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
    width="46pt" height="46pt" viewBox="0 0 40 35"
   preserveAspectRatio="xMidYMid meet">
  <g transform="translate(0.000000,31.000000) scale(0.100000,-0.100000)"
  fill="#fff" stroke="none">

<path d="M10 291 c0 -5 10 -11 23 -13 15 -2 23 -11 25 -28 4 -37 53 -170 63
-170 4 0 7 -12 6 -27 -2 -22 2 -28 18 -28 16 0 20 6 18 28 -1 22 2 27 22 27
20 0 23 -5 22 -27 -2 -24 2 -28 23 -28 22 0 25 4 26 37 l1 37 -66 4 -66 3 67
2 66 2 17 53 c10 28 21 56 26 61 5 6 9 16 9 23 0 10 -27 13 -115 13 -104 0
-115 2 -125 20 -11 20 -60 29 -60 11z m256 -101 l-10 -50 -68 0 c-74 0 -75 1
-94 75 l-6 25 94 0 95 0 -11 -50z"/>


  </g>
</svg>
);};

const SvgMov03 = () => {return(
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
    width="46pt" height="46pt" viewBox="0 0 40 35"
   preserveAspectRatio="xMidYMid meet">
  <g transform="translate(0.000000,31.000000) scale(0.100000,-0.100000)"
  fill="#fff" stroke="none">

<path d="M40 150 l0 -90 145 0 145 0 0 90 0 90 -145 0 -145 0 0 -90z m86 48
c-21 -29 -20 -67 1 -90 15 -17 14 -18 -20 -18 l-37 0 0 65 0 65 36 0 c34 0 35
-1 20 -22z m174 -43 l0 -65 -35 0 -36 0 16 29 c16 31 12 54 -13 84 -14 16 -12
17 26 17 l42 0 0 -65z m-135 31 c-19 -14 -19 -15 -1 -35 12 -13 14 -21 7 -21
-7 0 -9 -4 -6 -10 3 -6 -1 -7 -9 -4 -30 12 -14 84 18 84 5 0 1 -6 -9 -14z m60
-17 c7 -22 -11 -59 -28 -59 -7 0 -6 4 3 10 12 8 13 13 2 30 -8 14 -9 20 -1 20
8 0 8 5 -1 15 -11 13 -10 14 3 9 9 -3 19 -14 22 -25z"/>


  </g>
</svg>
);};

const SvgMov04 = () => {return(
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
    width="46pt" height="46pt" viewBox="0 0 40 35"
   preserveAspectRatio="xMidYMid meet">
  <g transform="translate(0.000000,31.000000) scale(0.100000,-0.100000)"
  fill="#fff" stroke="none">

<path d="M10 160 l0 -140 120 0 120 0 0 113 c0 111 -1 114 -28 140 -26 25 -34
27 -120 27 l-92 0 0 -140z m160 90 c0 -27 3 -30 30 -30 l30 0 0 -90 0 -90
-100 0 -100 0 0 120 0 120 70 0 70 0 0 -30z m40 5 c10 -12 10 -15 -4 -15 -9 0
-16 7 -16 15 0 8 2 15 4 15 2 0 9 -7 16 -15z"/>
<path d="M52 95 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M70 95 c0 -14 5 -25 10 -25 6 0 10 11 10 25 0 14 -4 25 -10 25 -5 0
-10 -11 -10 -25z"/>
<path d="M102 95 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M132 95 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M150 95 c0 -14 5 -25 10 -25 6 0 10 11 10 25 0 14 -4 25 -10 25 -5 0
-10 -11 -10 -25z"/>
<path d="M182 95 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M200 95 c0 -14 5 -25 10 -25 6 0 10 11 10 25 0 14 -4 25 -10 25 -5 0
-10 -11 -10 -25z"/>

  </g>
</svg>
);};

const SvgMov05 = () => {return(
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
    width="46pt" height="46pt" viewBox="0 0 40 35"
   preserveAspectRatio="xMidYMid meet">
  <g transform="translate(0.000000,31.000000) scale(0.100000,-0.100000)"
  fill="#fff" stroke="none">


<path d="M102 188 c-7 -7 -12 -27 -12 -45 0 -23 -5 -33 -15 -33 -12 0 -15 -14
-15 -70 l0 -70 90 0 90 0 0 70 c0 56 -3 70 -15 70 -10 0 -15 10 -15 33 0 18
-5 38 -12 45 -16 16 -80 16 -96 0z m78 -48 c0 -27 -3 -30 -30 -30 -27 0 -30 3
-30 30 0 27 3 30 30 30 27 0 30 -3 30 -30z m30 -100 l0 -40 -60 0 -60 0 0 40
0 40 60 0 60 0 0 -40z"/>
<path d="M730 138 c0 -7 5 -20 10 -28 9 -13 11 -13 20 0 16 24 12 40 -10 40
-11 0 -20 -6 -20 -12z"/>


  </g>
</svg>
);};



const SvgPDV = () => {return(

    <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
     width="58.000000pt" height="63.000000pt" viewBox="0 0 58.000000 63.000000"
     preserveAspectRatio="xMidYMid meet">
    
    <g transform="translate(0.000000,63.000000) scale(0.100000,-0.100000)"
    fill="#fff" stroke="none">
    <path d="M365 610 c-3 -5 -17 -10 -30 -10 -25 0 -64 -45 -59 -68 1 -7 0 -8 -3
    -2 -2 5 -16 10 -29 10 -17 0 -24 -6 -24 -18 0 -10 -12 -25 -27 -33 -16 -7 -39
    -21 -52 -31 -13 -10 -32 -18 -42 -18 -16 0 -19 -8 -19 -42 0 -24 -3 -92 -6
    -153 l-7 -110 100 -68 100 -68 46 22 c36 18 47 28 47 47 l0 24 36 -23 36 -22
    50 24 50 23 -6 96 c-3 52 -9 143 -12 201 l-6 107 -29 6 c-25 5 -29 10 -29 39
    0 18 -7 43 -16 55 -16 23 -58 30 -69 12z m65 -19 c5 -11 10 -33 10 -49 0 -26
    -3 -29 -25 -24 -15 2 -25 11 -25 21 0 9 -7 26 -15 37 -8 12 -11 24 -8 28 14
    13 53 5 63 -13z m-66 -17 c20 -20 20 -34 1 -34 -8 0 -16 10 -16 23 l-2 22 -4
    -23 c-3 -16 -9 -22 -20 -18 -8 3 -19 6 -24 6 -6 0 -5 8 1 20 13 24 43 26 64 4z
    m-13 -44 c22 0 29 -5 29 -20 0 -11 -2 -20 -5 -20 -16 0 -85 34 -85 42 0 6 7 7
    16 4 9 -3 29 -6 45 -6z m14 -46 c28 -9 54 -20 59 -25 9 -8 -3 -389 -13 -389
    -3 0 -16 8 -28 18 -21 16 -23 28 -29 154 l-7 137 -34 12 c-27 9 -33 15 -33 40
    0 19 -10 39 -25 55 -48 48 -34 48 110 -2z m74 20 c34 -7 40 -18 15 -28 -23 -9
    -64 4 -64 20 0 16 5 17 49 8z m-221 -44 c0 -23 -4 -30 -19 -30 -22 0 -26 28
    -4 36 8 4 12 10 9 15 -3 5 -1 9 4 9 5 0 9 -13 10 -30z m42 11 c14 -28 12 -61
    -4 -61 -14 0 -26 29 -26 63 0 23 17 22 30 -2z m254 -238 l6 -133 -41 -20 c-22
    -12 -43 -19 -46 -16 -3 3 -2 93 2 201 l7 196 27 13 26 14 6 -61 c4 -34 9 -122
    13 -194z m-334 233 c0 -3 -6 -11 -14 -19 -13 -12 -9 -16 25 -26 28 -8 39 -17
    39 -31 0 -19 -1 -19 -45 2 -48 23 -51 28 -35 59 9 16 30 27 30 15z m-50 -36
    c0 -5 -5 -10 -11 -10 -5 0 -7 5 -4 10 3 6 8 10 11 10 2 0 4 -4 4 -10z m135
    -248 c-4 -87 -9 -159 -10 -161 -3 -2 -118 74 -174 115 -2 2 0 68 4 147 l7 145
    90 -45 90 -45 -7 -156z m35 202 c39 -16 40 -18 40 -63 0 -25 3 -96 7 -158 l6
    -111 -43 -22 -43 -22 6 128 c4 71 7 148 7 172 0 30 4 42 14 42 8 0 17 4 21 9
    3 6 -6 7 -22 2 -36 -10 -53 -4 -53 20 0 23 8 24 60 3z"/>
    </g>
    </svg>
    );};
      
      
    
    const SvgLic = () => {
      return (
    <svg fill="#fff" height="64px" width="64px" version="1.1" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 24 24">
        <g  stroke-linecap="round" stroke-linejoin="round"></g>
      <g> 
        <g> <path d="M6,9C4.3,9,3,7.7,3,6s1.3-3,3-3s3,1.3,3,3S7.7,9,6,9z M6,5C5.4,5,5,5.4,5,6s0.4,1,1,1s1-0.4,1-1S6.6,5,6,5z"></path> </g> 
        <g> <path d="M24,24h-6.4L15,21.4V20h-3v-3H9v-3.3C8.4,13.9,7.7,14,7,14c-3.9,0-7-3.1-7-7s3.1-7,7-7s7,3.1,7,7c0,0.5,0,1-0.1,1.4 L24,18.6V24z M18.4,22H22v-2.6L11.6,9l0.2-0.6C11.9,8,12,7.5,12,7c0-2.8-2.2-5-5-5S2,4.2,2,7s2.2,5,5,5c0.7,0,1.4-0.1,2.1-0.4 l0.6-0.3l1.3,1.3V15h3v3h3v2.6L18.4,22z"></path> </g> 
        </g> 
    </svg>
    );
    };
    
    
    const SvgLogout = () => {
      return (
    <svg xmlns="http://www.w3.org/2000/svg" 
     width="64px" height="64px" viewBox="0 0 12 12" enable-background="new 0 0 12 12"  
     version="1.1"  fill="#fff" transform="matrix(-1, 0, 0, 1, 0, 0)">
    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/><g>
    <polygon fill="#fff" points="9,2 9,0 1,0 1,12 9,12 9,10 8,10 8,11 2,11 2,1 8,1 8,2 "/>
    <polygon fill="#fff" points="8.2929688,3.2929688 7.5859375,4 9.0859375,5.5 5,5.5 5,6.5 9.0859375,6.5 7.5859375,8 8.2929688,8.7070313 11,6 "/>
    </g>
    </svg>
    );
    };
    
    const SvgUser = () => {
      return (
    <svg width="64px" height="64px" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g stroke-linecap="round" stroke-linejoin="round"></g>
    <g> <path d="M8 7C9.65685 7 11 5.65685 11 4C11 2.34315 9.65685 1 8 1C6.34315 1 5 2.34315 5 4C5 5.65685 6.34315 7 8 7Z" 
    fill="#fff"></path> <path d="M14 12C14 10.3431 12.6569 9 11 9H5C3.34315 9 2 10.3431 2 12V15H14V12Z" 
    fill="#fff"></path> 
    </g>
    </svg>
    );
    };
    
    const SvgEnviar = () => {
        return (
      <svg width="64px" height="64px" viewBox="0 -8 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g fill="white">
      <path d="M13.3085 0.293087C13.699 -0.0976958 14.3322 -0.0976956 14.7227 0.293087L17.7186 3.29095C18.1091 3.68175 18.1091 4.31536 17.7185 4.70613L14.716 7.71034C14.3255 8.10113 13.6923 8.10113 13.3018 7.71034C12.9113 7.31956 12.9113 6.68598 13.3018 6.2952L14.6087 4.98743L7 4.98743C6.44771 4.98743 6 4.53942 6 3.98677C6 3.43412 6.44771 2.98611 7 2.98611L14.5855 2.9861L13.3085 1.70824C12.918 1.31745 12.918 0.683869 13.3085 0.293087Z" />
      </g>
      </svg>
        )
      };
      

      const SvgVolta = () => {
        return (
      <svg width="26px" height="26px" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" 
        fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g>
        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
        <g id="SVGRepo_iconCarrier"> <path d="M0 0h48v48H0z" fill="none"></path> 
        <g id="Shopicon"> 
          <path fill="#fff" d="M10,22v2c0,7.72,6.28,14,14,14s14-6.28,14-14s-6.28-14-14-14h-4V4l-8,8l8,8v-6h4c5.514,0,10,4.486,10,10s-4.486,10-10,10 s-10-4.486-10-10v-2H10z">
          </path> 
          </g> 
          </g>
      </svg>
      ); };      
  
const SvgSairMenu = () => {
return (
<svg width="42px" height="42px" viewBox="0 -0.5 21 21" version="1.1" fill="#fff">
<g transform="translate(-59.000000, -200.000000)" fill="#fff">
<g transform="translate(56.000000, 160.000000)" fill="#fff">
<path d="M14.55,60 L24,60 L24,51 L14.55,51 L14.55,60 Z M3,60 L12.45,60 L12.45,51 L3,51 L3,60 Z M14.55,49 L24,49 L24,40 L14.55,40 L14.55,49 Z M3,49 L12.45,49 L12.45,40 L3,40 L3,49 Z" id="menu_navigation_grid-[#1530]"> </path> 
</g> 
</g> 
</svg>
); };      
            


const SvgVolta2 = () => {
return (
<svg width="42px" height="42px" viewBox="-1 0 32 32" version="1.1" fill="#fff">
<path d="M5.333 12.533v17.707h24.533v-24.533h-19.2v-4l-10.667 7.253 5.333 3.573zM9.6 5.76c0 0 0 0.053 0 0v0 1.067h1.013c0 0 0 0 0.053 0 0 0 0.053 0 0.053 0h0.053c5.013 0 8.32 2.773 9.76 6.293-3.040-2.56-6.987-2.88-8.907-2.88-0.053 0-0.053 0-0.107 0h-1.92v1.067c0 0 0 0 0 0v2.827l-7.68-5.173 7.68-5.227v2.027zM6.4 13.28l4.267 2.88v-4.8c0.213 0 0.533-0.053 0.96-0.053 2.667 0 8.373 0.693 10.773 6.133 0-4.48-2.293-8.693-6.56-10.613h12.96v22.4h-22.4v-15.947z" fill="#fff"> </path> 
</svg>        
); };      


  const SvgOk = () => {
    return (
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 500 500" width="42px" height="42px" fill="#000000">
  <g   fill="none" stroke="#000" stroke-width="4">
  <path fill="#fff" d="M455.3,61.5C395.6,69.1,300.9,153.7,222,276c-6.1,9.4-11.9,18.8-17.4,28.1c0,0,0,0-0.1-0.1 c-0.1,0.1-0.1,0.2-0.2,0.3c-12.8-12.8-26.6-25.6-41.2-38.1c-6.8-5.8-13.6-11.4-20.3-16.9L40.2,314.2c46.9,22,87.8,48.2,119.6,75.3 c0-0.1,0.1-0.2,0.1-0.3c19.1,16.3,35,33,46.8,49.3c5.2-7.7,10.5-15.4,16-23.2c12-17.1,24.2-33.5,36.4-49.1c0,0,0.1,0.1,0.1,0.1 c81.4-104.5,162.3-173.5,200.6-170.6L455.3,61.5z"></path> 
  </g>
  </svg>
  );
  };
  

  
const SvgDelete = () => {
    return (
    <svg height="16" width="16" xmlns="http://www.w3.org/2000/svg" >
    <path d="M1 1 L14 15 M1 15 L15 1"   fill="none"   stroke="#000"   stroke-width="4"    />
    </svg>
    ); };
    
    const SvgNew = () => {
      return (
      <svg height="16" width="16" xmlns="http://www.w3.org/2000/svg" >
      <path d="M1 8 L15 8 M8 15 L8 1"   fill="none"   stroke="#fff"   stroke-width="4"    /> </svg>
      ); };
    
      const SvgNew2 = () => {
        return (
        <svg height="42" width="42" xmlns="http://www.w3.org/2000/svg" >
        <path d="M1 8 L15 8 M8 15 L8 1"   fill="none"   stroke="#fff"   stroke-width="4"    /> </svg>
        ); };
              

    const SvgVideo = () => {
      return (
      <svg width="52px" height="52px" viewBox="-4.8 -8.8 25.60 25.60" 
      xmlns="http://www.w3.org/2000/svg" stroke="#ff0000" stroke-width="0.096" 
      transform="matrix(1, 0, 0, 1, 0, 0)rotate(0)">
      <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" 
      stroke="#fff" stroke-width="1.3439999999999999"> 
        <path fill-rule="evenodd" clip-rule="evenodd" 
        d="M16 2H0V14H16V2ZM6.5 5V11H7.5L11 8L7.5 5H6.5Z" fill="none"></path>
       </g>
      </svg>
      );
    };
    
    const SvgPage = () => {
      return (
      <svg width="32px" height="32px" viewBox="0 0 32 32" enableBackground="new 0 0 32 32" id="_x3C_Layer_x3E_" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="#000000">
      <g id="SVGRepo_bgCarrier" strokeWidth="2">
      <polyline fill="none" id="XMLID_2947_" points=" 21.5,1.5 4.5,1.5 4.5,30.5 27.5,30.5 27.5,7.5 " 
            stroke="white" strokeLinecap="round" strokeLinejoin="round" />
      <polyline fill="none" id="XMLID_2946_" points=" 21.5,1.5 27.479,7.5 21.5,7.5 21.5,2 " 
            stroke="white" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      </svg>
    );
    };

    
    const SvgEdit = () => {
      return (
    <svg height="16" width="16" xmlns="http://www.w3.org/2000/svg" >
      <path d="M4.5 10 L13 1 M1 14 L4.2 10.8"
      fill="none"
      stroke="#000"
      stroke-width="4" />
    </svg>
    );
    };
    
 
    
    
    const SvgPC = () => {
      return (
    <svg height="16" width="16" xmlns="http://www.w3.org/2000/svg" >
    <path d="M15 1 L15 10 L1 10 L1 1 L16 1 M7 12 L9 12 M3 14 L13.2 14"
      fill="none"
      stroke="#000"
      stroke-width="2" 
      />
    </svg>
    );
    };
    
    const SvgPdf = () => {
      return (
    <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" 
    fill="currentColor" viewBox="0 0 16 16">
      <path d="M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1"/>
      <path d="M4.603 12.087a.8.8 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.7 7.7 0 0 1 1.482-.645 20 20 0 0 0 1.062-2.227 7.3 7.3 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.187-.012.395-.047.614-.084.51-.27 1.134-.52 1.794a11 11 0 0 0 .98 1.686 5.8 5.8 0 0 1 1.334.05c.364.065.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.86.86 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.7 5.7 0 0 1-.911-.95 11.6 11.6 0 0 0-1.997.406 11.3 11.3 0 0 1-1.021 1.51c-.29.35-.608.655-.926.787a.8.8 0 0 1-.58.029m1.379-1.901q-.25.115-.459.238c-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361q.016.032.026.044l.035-.012c.137-.056.355-.235.635-.572a8 8 0 0 0 .45-.606m1.64-1.33a13 13 0 0 1 1.01-.193 12 12 0 0 1-.51-.858 21 21 0 0 1-.5 1.05zm2.446.45q.226.244.435.41c.24.19.407.253.498.256a.1.1 0 0 0 .07-.015.3.3 0 0 0 .094-.125.44.44 0 0 0 .059-.2.1.1 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a4 4 0 0 0-.612-.053zM8.078 5.8a7 7 0 0 0 .2-.828q.046-.282.038-.465a.6.6 0 0 0-.032-.198.5.5 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822q.036.167.09.346z"/>
    </svg>
      );
    };
    
    const SvgMod = () => {
      return (
      <svg width="30px" height="30px" viewBox="-4.8 -8.8 25.60 25.60" 
      xmlns="http://www.w3.org/2000/svg" stroke="#ff0000" stroke-width="0.096" 
      transform="matrix(1, 0, 0, 1, 0, 0)rotate(0)">
      <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" 
      stroke="#000" stroke-width="1.3439999999999999"> 
        <path fill-rule="evenodd" clip-rule="evenodd" 
        d="M16 2H0V14H16V2Z 5H6.5Z" fill="none"></path>
       </g>
      </svg>
      );
    };

const SvgInativo = () => {
    return (
<svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px"  viewBox="0 -28 75 75" fill="#000000">
<g transform="translate(-309.723 -164.741)" fill="#000"> 
   <circle  cx="-15" cy="15" r="15" transform="translate(347.784 172.134)"/> 
   <path  d="M362.833,208.129a20.944,20.944,0,0,0,0-41.888H332.167a20.944,20.944,0,1,0,0,41.888Z" fill="none" stroke="#000000" stroke-miterlimit="10" stroke-width="3"/> 
</g> 
</svg>
  );
};

const SvgAtivo = () => {
  return (
<svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px"  viewBox="0 -28 75 75" fill="#000000">
<g transform="translate(-309.723 -164.741)" fill="#000"> 
 <circle  cx="15" cy="15" r="15" transform="translate(347.784 172.134)"  fill="green"/> 
 <path  d="M362.833,208.129a20.944,20.944,0,0,0,0-41.888H332.167a20.944,20.944,0,1,0,0,41.888Z" fill="none" stroke="#000000" stroke-miterlimit="10" stroke-width="3"/> 
</g> 
</svg>
);
};


const SvgManual = () => {
  return (
<svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" fill="currentColor"  viewBox="0 0 16 16">
  <path d="M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1"/>
  <path id="lineAC" d="M 3.5 0 L3.5 16 " stroke="none" strokeWidth="2" fill="none"/>
  <text fill="#fff" font-size="3.7px">
      <textPath href="#lineAC" startOffset="1.5">Manual</textPath>
  </text>
</svg>
  );
};


const SvgDonwload = () => {
  return (
<svg xmlns="http://www.w3.org/2000/svg" fill="#fff" height="32px" width="32px"   viewBox="0 0 29.978 29.978">
<g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round"  strokeLinejoin="round"></g>
<path 
d="M25.462,19.105v6.848H4.515v-6.848H0.489v8.861c0,1.111,0.9,2.012,2.016,2.012h24.967c1.115,0,2.016-0.9,2.016-2.012 v-8.861H25.462z">
  </path> 
<path d="M14.62,18.426l-5.764-6.965c0,0-0.877-0.828,0.074-0.828s3.248,0,3.248,0s0
-0.557,0-1.416c0-2.449,0-6.906,0-8.723 c0,0-0.129-0.494,0.615-0.494c0.75,0,4.035,0,4.572,0c0.536,0,0.524,0.416,0.524,
0.416c0,1.762,0,6.373,0,8.742 c0,0.768,0,1.266,0,1.266s1.842,0,2.998,0c1.154,0,0.285,0.867,0.285,0.867s-4.904,
6.51-5.588,7.193 C15.092,18.979,14.62,18.426,14.62,18.426z">
</path> 
</svg>
  );
};


export {SvgTab01, SvgTab02, SvgTab03, SvgTab04, SvgTab05, SvgTab06, SvgTab07, SvgTab08, 
    SvgTab09, SvgTab10, SvgMov01, SvgMov02, SvgMov03, SvgMov04, SvgMov05, SvgLogin, 
    SvgPDV,  SvgUser, SvgLic, SvgLogout, SvgEnviar, SvgVolta, SvgVolta2, SvgSairMenu, SvgOk, SvgPdf,
    SvgNew, SvgNew2, SvgDelete, SvgPage, SvgEdit, SvgVideo, SvgPC, Valorbr0, Valorbr2, SvgMod,
    SvgAtivo, SvgInativo, SvgManual, SvgDonwload}

